import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram, Linkedin, Mail, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/lib/content";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="section-dark relative overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          {/* Big statement */}
          <div className="md:col-span-7">
            <p className="overline text-[#189A96]">Let's build something clean</p>
            <h2 className="font-serif text-5xl md:text-7xl mt-6 leading-[0.95] text-[#F8FAFC]">
              Ready to specify
              <br />
              <span className="text-[#189A96] italic">healthier surfaces?</span>
            </h2>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link
                to="/contact"
                data-testid="footer-cta-quote"
                className="btn-primary"
              >
                Request a Quote <ArrowUpRight className="w-4 h-4" />
              </Link>
              <a
                href={`mailto:${BRAND.email}`}
                data-testid="footer-email-link"
                className="btn-ghost"
              >
                <Mail className="w-4 h-4" />
                {BRAND.email}
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="md:col-span-2 md:col-start-8">
            <p className="overline mb-6">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-[#F8FAFC]/80 hover:text-[#189A96] font-sans text-sm"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="flex gap-4 mt-14">
              
              <a
                href="#"
                aria-label="Instagram"
                className="w-10 h-10 border border-[#F8FAFC]/20 flex items-center justify-center hover:bg-[#189A96] hover:border-[#189A96] transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="#"
                aria-label="LinkedIn"
                className="w-10 h-10 border border-[#F8FAFC]/20 flex items-center justify-center hover:bg-[#189A96] hover:border-[#189A96] transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              
            </div>
          </div>
          

          <div className="md:col-span-5 md:col-start-10">
            <p className="overline mb-6">Address</p>
            <p className="text-[#F8FAFC]/80 text-sm font-sans leading-relaxed whitespace-pre-line">
              {BRAND.address}
            </p>
            <p className="text-[#F8FAFC]/80 text-sm font-sans mt-3">
              {BRAND.phone}
            </p>
             <div className="flex gap-4 mt-10">
              <Link
                to="/contact"
                aria-label="Get directions"
                className="w-10 h-10 border border-[#F8FAFC]/20 flex items-center justify-center hover:bg-[#189A96] hover:border-[#189A96] transition-colors"
              >
                <MapPin className="w-4 h-4" />
              </Link>
             </div>
          </div>
        </div>

      </div>

      {/* Oversized wordmark -- full-bleed so its vw-based size scales
          against the viewport, not the max-w-constrained content column
          above (that mismatch was clipping the trailing "E"). */}
      <div className="border-t border-[#F8FAFC]/10 pt-16 overflow-hidden">
        <div className="font-serif text-[15vw] leading-[0.8] tracking-[-0.04em] text-[#F8FAFC]/[0.08] select-none whitespace-nowrap px-6 md:px-10">
          GOHEALTHE
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-8 pb-10">
        <div className="flex flex-col md:flex-row justify-between gap-4 text-xs font-sans text-[#F8FAFC]/50">
          <p>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
          <p>Silver-ion cladding · Cleanroom systems · Fabrication</p>
        </div>
      </div>
    </footer>
  );
}
